export default "__VITE_ASSET__71e038e9__"